export default __webpack_public_path__ + "static/media/2.378028d3.png";